import React, { Component } from "react";
import G2 from "@antv/g2";
import moment from "moment";
import { equals } from "ramda";
import i18n from "../../i18n";
import { withTheme } from "styled-components";
import { calFrequencyGraph, calFrequencyTitle } from "../../util/graph";
import { Container } from "./individual_user/style";
import GenerateUtil from "../../util/helper/generate";
import ColorUtil from "../../util/ColorUtil";
const { makeId } = GenerateUtil;

class FrequencyGraph extends Component {
    state = {
    	title: "All Time"
    }

    componentWillReceiveProps(nextProps) {
    	const { data, date_range } = nextProps;
    	if (this.date_range != date_range) {
    		if (!date_range && !date_range[0] && !date_range[1])
    			this.setState({ title: "All Time" });
    		else {
    			this.setState({ title: calFrequencyTitle(date_range) });
    		}
    	}

    	const newData = calFrequencyGraph(data ? Object.keys(data).map((key, index) => {
    		return { date: moment.unix(key).format("D/MM/YYYY"), value: data[key] };
    	}) : [], date_range);
    	this.chart.source(newData);
    	this.chart.render();
    }

    componentDidMount = () => {
    	const { chart_id, data, date_range, theme, visualColorKey } = this.props;
    	this.date_range = date_range;
    	const newData = calFrequencyGraph(data ? Object.keys({ data }).map((key, index) => {
    		return { date: moment.unix(key).format("D/MM/YYYY"), value: data[key] };
    	}) : [], date_range);
    	this.chart = new G2.Chart({
    		container: chart_id,
    		height: 150,
    		padding: [50, 10, 50, 10],
    		forceFit: true
    	});
    	this.chart.source(newData);
    	this.chart.axis(false);
    	this.chart.scale("date", {
    		range: [0, 1]
    	});
    	const color = ColorUtil.getVisualizeColor(theme, visualColorKey, 0, 1);
    	this.chart.line().position("date*value").style({
    		stroke: color,
    	});
    	this.chart.line().position("date*value").style({
    		stroke: color
    	});
    	this.chart.point().position("date*value").size(3).shape("circle").style({
    		fill: color
    	});
    	this.chart.render();
    	this.setState({ title: calFrequencyTitle(date_range) });

    	window.dispatchEvent(new Event("resize"));
    }
    shouldComponentUpdate(nextProps, nextState){
    	return !equals(this.props.date_range, nextProps.date_range) || 
			!equals(this.props.data, nextProps.data) || !equals(this.state, nextState);
    }
    render() {
    	const { chart_id, containerStyle } = this.props;
    	const { title } = this.state;
    	return (
    		<Container style={{ ...containerStyle }}>
    			<div style={{ fontSize: 18 }}>{`${i18n.t("visit_frequency")} (${i18n.t("time.label")})`}</div>
    			<div style={{ fontSize: 14 }}>{title}</div>
    			<div id={chart_id} />
    		</Container>
    	);
    }
}

// const data = [
//     { date: '29/1/2018', value: 1 },
//     { date: '30/1/2018', value: 1 },
//     { date: '9/2/2018', value: 10 },
//     { date: '13/2/2016', value: 8 },
// ];

export default withTheme(FrequencyGraph);


// WEBPACK FOOTER //
// ./src/components/report/FrequencyGraph.js